import { CHARTER_FLIGHT_DETAILS } from 'constants/charterFlight'

export function isConfiguredFeederOriginAirportCode(
  charterBundleRoute: App.CharterBundleRoute | undefined,
  airportCode: string | undefined,
): boolean {
  if (!charterBundleRoute || !airportCode) {
    return false
  }

  const routeInfo = CHARTER_FLIGHT_DETAILS[charterBundleRoute]
  return routeInfo.feederFlightOrigins.some(airport => airport.airportCode === airportCode)
}

export function getFeederOriginAirportCode(
  charterBundleRoute: App.CharterBundleRoute | undefined,
  flightOrigin: App.Airport | undefined,
): string | undefined {
  if (!charterBundleRoute || !flightOrigin) {
    return undefined
  }

  const routeInfo = CHARTER_FLIGHT_DETAILS[charterBundleRoute]
  return flightOrigin.code !== routeInfo.originAirport.airportCode &&
    isConfiguredFeederOriginAirportCode(charterBundleRoute, flightOrigin.code)
    ? flightOrigin.code
    : undefined
}

/**
 * Returns true when at least one of the two charter legs carries a positive
 * `feederEstimatedPrice`. svc-flights only attaches this field when the search was
 * eligible (charter source + economy + non-MEL feeder origin) AND the FDA returned
 * a feeder price for that leg/date. When both legs are missing or sum to 0 the
 * bundle is effectively a non-feeder charter for those dates.
 */
export function hasFeederFlightPriced(
  departingJourney: Pick<App.JourneyV2, 'feederEstimatedPrice'> | undefined,
  returningJourney: Pick<App.JourneyV2, 'feederEstimatedPrice'> | undefined,
): boolean {
  const total = (departingJourney?.feederEstimatedPrice ?? 0) + (returningJourney?.feederEstimatedPrice ?? 0)
  return total > 0
}

export function canAddCharterBundleToUserCart({
  charterBundleRoute,
  flightOrigin,
}: {
  charterBundleRoute?: App.CharterBundleRoute
  flightOrigin?: App.Airport
}): boolean {
  if (!charterBundleRoute) {
    return true
  }

  if (!flightOrigin) {
    return false
  }

  const routeInfo = CHARTER_FLIGHT_DETAILS[charterBundleRoute]
  return flightOrigin.code === routeInfo.originAirport.airportCode
}
